/**
 * Transform the new states-cities.json format (object with state names as keys and city arrays as values)
 * into the expected State[] format for components
 */

interface City {
  id: number;
  name: string;
  latitude: string;
  longitude: string;
}

interface State {
  id: number;
  name: string;
  state_code: string;
  latitude: string;
  longitude: string;
  type: string;
  cities: City[];
}

export function transformStatesCitiesData(
  rawData: Record<string, string[]>
): State[] {
  let id = 1;
  return Object.entries(rawData).map(([stateName, cities]) => {
    const stateId = id++;
    return {
      id: stateId,
      name: stateName,
      state_code: stateName.substring(0, 2).toUpperCase(),
      latitude: "0",
      longitude: "0",
      type: "state",
      cities: cities.map((cityName, index) => ({
        id: stateId * 1000 + index,
        name: cityName,
        latitude: "0",
        longitude: "0",
      })),
    };
  });
}
